<div class="auth-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5 col-xl-4">
        <div class="card h-auto">
          <div class="card-body">
            <div class="text-center mb-4">
              <a
                ><img class="logo-auth" src="../../../../../assets/images/logo.svg" alt="logo"
              /></a>
            </div>
              <spinner *ngIf="loading"></spinner>
            <h4 class="text-center mb-4">Sign In</h4>
              <p>We have just sent you an One-Time Password (OTP) via email. Please check your inbox and enter the code below.</p>
              <p>&nbsp;</p>
            <form  [formGroup]="signinForm" (ngSubmit)="onSubmit()">
              <div class="form-group mb-3">
                <input
                  type="number"
                  min="0"
                  max="999999"
                  id="otp"
                  formControlName="otp"
                  class="form-control"
                  placeholder="Enter your OTP here"
                />
                @if(signinForm.get('otp').invalid && (signinForm.get('otp').dirty || signinForm.get('otp').touched)){
                  <div class="text-danger">This field is required and must be valid.</div>
                }
              </div>

              <div class="text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  [disabled]="signinForm.invalid"
                >
                  Submit
                </button>
              </div>
              <div class="text-center">
                <a [routerLink]="['/signin']"
                  class="btn btn-link py-3 btn-link-small">
                  Back to sign-in
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
